import { NavLink } from "react-router-dom";
import { PaintBrushBroad, X } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { CREATIVE_NAV } from "../nav";

const SECTION_LABELS = {
  library: "Library",
  operations: "Operations",
};

export function CreativeSidebar({ mobileOpen, onClose }) {
  const nav = (
    <nav className="flex-1 space-y-0.5 overflow-y-auto p-3" data-testid="creative-nav">
      {CREATIVE_NAV.map(({ to, key, label, Icon, end, section }) => {
        const item = (
          <NavLink
            key={key}
            to={to}
            end={end}
            onClick={onClose}
            data-testid={`creative-nav-${key}`}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                isActive
                  ? "border border-brand/25 bg-brand/10 font-medium text-brand"
                  : "border border-transparent text-foreground/80 hover:bg-accent/60 hover:text-foreground",
              )
            }
          >
            <Icon size={18} weight="duotone" />
            {label}
          </NavLink>
        );
        if (section) {
          return (
            <div key={`sec-${key}`}>
              <div className="mb-1 mt-4 border-t border-border/60 pt-3 promo-overline px-3" data-testid={`creative-section-${section}`}>
                {SECTION_LABELS[section] || section}
              </div>
              {item}
            </div>
          );
        }
        return item;
      })}
    </nav>
  );

  const inner = (
    <>
      <div className="flex h-16 shrink-0 items-center gap-2.5 border-b border-border px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-md bg-ai text-ai-foreground">
          <PaintBrushBroad size={18} weight="fill" />
        </div>
        <div className="leading-none">
          <div className="font-heading text-sm font-medium tracking-tight">Creative Studio</div>
          <div className="promo-overline mt-1">GrowthAI</div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-auto rounded-md p-1 text-muted-foreground hover:bg-accent md:hidden"
            data-testid="creative-sidebar-close"
          >
            <X size={18} />
          </button>
        )}
      </div>
      {nav}
      <div className="shrink-0 border-t border-border p-4">
        <div className="promo-overline mb-2">Powered by</div>
        <div className="rounded-md border border-border bg-card/60 px-3 py-2 text-xs text-muted-foreground">
          Enterprise AI Creative Generation
        </div>
      </div>
    </>
  );

  return (
    <>
      <aside
        className="hidden w-64 shrink-0 flex-col border-r border-border bg-card md:flex"
        data-testid="creative-sidebar"
      >
        {inner}
      </aside>

      {mobileOpen && (
        <div className="fixed inset-0 z-50 md:hidden" data-testid="creative-sidebar-mobile">
          <div className="absolute inset-0 bg-background/70 backdrop-blur-sm" onClick={onClose} />
          <aside className="absolute left-0 top-0 flex h-full w-64 flex-col border-r border-border bg-card">
            {inner}
          </aside>
        </div>
      )}
    </>
  );
}
